import { Link } from 'react-router-dom';

const latestCards = [
  {
    id: 'article-1',
    slug: 'dingzhen-chugui-baoguang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20nighttime%20scene%20outside%20a%20luxury%20hotel%20in%20Beijing%20with%20paparazzi%20atmosphere%20dim%20lighting%20a%20luxury%20car%20parked%20near%20the%20entrance%20mysterious%20silhouettes%20cinematic%20moody%20tones%20editorial%20photography&width=600&height=375&seq=latest-article-dingzhen&orientation=landscape',
    category: '明星八卦',
    title: '某知名男星深夜密会神秘女子，酒店共度8小时，出轨实锤曝光',
    excerpt: '据知情人士透露，该男星与妻子结婚仅两年，此次被拍到与一名年轻女子深夜进入某五星级酒店。',
    date: '2026-07-06',
    readCount: '28.6万',
    commentCount: 4832,
  },
  {
    id: 'article-2',
    slug: 'wanghong-zhibo-fanche',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20influencer%20livestreaming%20in%20a%20bright%20studio%20filled%20with%20products%20shocked%20expression%20on%20face%20dramatic%20moment%20warm%20lighting%20modern%20livestream%20setup%20editorial%20photography%20high%20detail&width=600&height=375&seq=latest-article-livestream&orientation=landscape',
    category: '网红黑料',
    title: '千万粉丝网红直播带货翻车，假货被当场拆穿，场面一度失控',
    excerpt: '该网红在直播间声称销售的是"正品大牌"，却被消费者当场拿出专柜鉴定报告打脸。',
    date: '2026-07-06',
    readCount: '19.8万',
    commentCount: 3215,
  },
  {
    id: 'article-3',
    slug: 'nvyouxing-zhengrong-fengbo',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20comparison%20style%20image%20showing%20dramatic%20before%20and%20after%20beauty%20transformation%20elegant%20woman%20in%20soft%20lighting%20beauty%20clinic%20aesthetic%20editorial%20photography%20minimal%20background%20warm%20tones&width=600&height=375&seq=latest-article-plastic&orientation=landscape',
    category: '明星八卦',
    title: '当红女星整容前后对比照流出，面部变化惊人，粉丝直呼认不出',
    excerpt: '有网友扒出该女星出道前的素颜照与近期活动照进行对比，鼻子、下巴、眼睛等部位变化明显。',
    date: '2026-07-05',
    readCount: '35.2万',
    commentCount: 5678,
  },
  {
    id: 'article-4',
    slug: 'douyin-wanghong-heilishi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20dramatic%20scene%20with%20smartphone%20screen%20displaying%20sensational%20news%20Chinese%20social%20media%20interface%20dim%20lighting%20atmosphere%20of%20revelation%20and%20mystery%20editorial%20photography%20style%20high%20contrast&width=600&height=375&seq=latest-article-scandal&orientation=landscape',
    category: '网红黑料',
    title: '抖音顶流网红黑历史被扒：曾参与网络诈骗，涉案金额高达数百万',
    excerpt: '有网友发现该网红早年曾因参与电信诈骗被警方抓获，相关裁判文书已在网上公开。',
    date: '2026-07-05',
    readCount: '42.2万',
    commentCount: 8921,
  },
  {
    id: 'article-5',
    slug: 'yulequan-qiang-juese',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20scene%20of%20Chinese%20film%20production%20set%20with%20warm%20spotlight%20dramatic%20shadows%20empty%20director%20chair%20contrasting%20light%20and%20dark%20areas%20cinematic%20atmosphere%20behind%20the%20scenes&width=600&height=375&seq=latest-article-role&orientation=landscape',
    category: '娱乐深扒',
    title: '娱乐圈抢角大战内幕曝光：某顶流靠资本运作抢走新人重要角色',
    excerpt: '圈内知情人士爆料，某S+级项目原定新人演员出演的主角，被顶流明星通过资本运作抢走。',
    date: '2026-07-04',
    readCount: '18.7万',
    commentCount: 2456,
  },
  {
    id: 'article-6',
    slug: 'kuaishou-zhubo-bei-ju',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20room%20late%20night%20scene%20with%20computer%20monitor%20showing%20banned%20account%20notice%20on%20Chinese%20streaming%20platform%20blue%20screen%20glow%20moody%20atmosphere%20dramatic%20lighting%20editorial%20photography&width=600&height=375&seq=latest-article-ban&orientation=landscape',
    category: '社会热点',
    title: '快手男主播酒后直播失言，发表不当言论遭全网封杀',
    excerpt: '该主播凌晨酒后开播，言语间发表多条不当言论，被网友录屏举报，账号已被永久封禁。',
    date: '2026-07-04',
    readCount: '23.5万',
    commentCount: 4125,
  },
];

export default function LatestGrid() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-18 lg:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 font-light tracking-wide mb-2">
            最新爆料
          </h2>
          <p className="text-sm text-foreground-500 font-light">每日更新，不错过任何一个大瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestCards.map((card) => (
            <article
              key={card.id}
              className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <Link to={`/article/${card.slug}`} className="block">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={card.imageUrl}
                    alt={card.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full">
                      {card.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                    {card.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{card.date}</span>
                    <div className="flex items-center gap-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {card.readCount}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line"></i>
                        {card.commentCount}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}